// extracted by mini-css-extract-plugin
module.exports = {"NewTagForm":"NewTagForm_NewTagForm__3tnW2","input":"NewTagForm_input__30WhL","rules":"NewTagForm_rules__1UfFV"};